import * as messageBus from '@wh/message-bus';
import { Store } from '@wh/store';

import { mergeConfig } from './config';
import { start as startLogic } from './framework/logic';
import startPorts from './framework/ports/createPortsFacade';
import createPortsInventory from './framework/ports/createPortsInventory';
import portsMap from './framework/ports/portsMap';
import appRenderer from './renderer';
import store from './store';

import './styles/index.scss';

window.WH = {
  messageBus,
  storages: {
    business: Store.getInstance('business'),
  },
};

startPorts(createPortsInventory(portsMap));
startLogic();
appRenderer(store);
mergeConfig(window.ASSEMBLER?.CONTEXT || {});
